import React, { useState, useEffect } from 'react'
import classes from './Recipes.module.css'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Form from "react-bootstrap/Form"
import { envAwarePost } from '../../util/util'
import Modal from "react-bootstrap/Modal"

const RecipesPublic = () => {

    const [modalRecipe, setModalRecipe] = useState({})
    const [show, setShow] = useState(false);
    const [recipes, setRecipes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        envAwarePost('api/recipesPublic/api', {
            action: 'readRecipesPublic'
        }).then(res => {
            setRecipes(res.data)
            setIsLoading(false);
        })

    }, [])

    const recipeSearchFilter = (recipe) => {
        if (Boolean(searchQuery)) {
            recipe = recipe.name.toLowerCase()
            return recipe.includes(searchQuery.toLowerCase())
        } else {
            return true;
        }
    }

    const handleSearchQuery = (e) => {
        setSearchQuery(e.target.value);
    }


    function createWebPUrls(url) {
        let webpUrl = "";
        let webpUrlCropped = "";
        if (url?.length > 0) {
            let imageArr = url.split(".");
            imageArr.pop();
            url = imageArr.join(".")
            webpUrl = url + ".webp"
            webpUrlCropped = url + "_cropped.webp"
        }
        return [webpUrl, webpUrlCropped];
    }

    return (
        <div style={{ background: "#000e2d", minHeight: "100vh" }} >
            <div className={`${classes.Recipes} mx-4`} style={{ paddingTop: "35px" }} id="containerDiv">
                <h1 className="pl-4 text-white" style={{ lineHeight: '1.5', marginBottom: 0 }}>Recipes</h1>
                <hr />
                <div className="pl-4 d-flex align-items-center justify-content-between w-100" >

                    <div className={`${classes.searchBar} d-flex`} >
                        <Form.Control
                            onChange={handleSearchQuery}
                            value={searchQuery}
                            placeholder="search recipes"
                            className="mx-1"
                        />
                    </div>


                </div>
                <hr />
                <div className={
                    classes.RecipeList}
                    style={{
                        background: "white",
                        border: "1px solid #e3e0e0",
                        borderRadius: "10px",
                        marginBottom: "0px"
                    }}>
                    {!isLoading ?
                        recipes.length ?
                            recipes.filter(r => (recipeSearchFilter(r))).map(recipe => {

                                let [webpUrl, webpUrlCropped] = createWebPUrls(recipe.image);

                                return <div
                                    key={recipe.id}
                                    className={classes.Recipe}
                                    onClick={() => {
                                        setModalRecipe({ ...recipe, webpUrl});
                                        setShow(true)
                                    }}>
                                    {recipe.image && (
                                        <picture >
                                            <source srcset={webpUrlCropped} type="image/webp" />
                                            <source srcset={webpUrl} type="image/webp" />
                                            <img src={recipe.image} alt="recipe image" style={{ width: "80px", height: "100%" }} loading="lazy" />
                                        </picture>)}
                                    <div className={classes.Body}>
                                        {recipe.name && <div className={classes.RecipeName}>{recipe.name}</div>}
                                        {recipe.macros?.length > 0 &&
                                            <div className={classes.MacrosList}>
                                                {recipe.macros.map(({ macro, qty, unit }) =>
                                                    <span className={classes.ModalMacros}>
                                                        {macro}: {qty} {(unit !== "") && `${unit}`}
                                                    </span>)}
                                            </div>
                                        }
                                        {recipe.link && <div><a href={recipe.link}>link</a></div>}
                                    </div>
                                </div>
                            }) :
                            <div style={{
                                height: '100vh',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexFlow: 'column'
                            }}>
                                <strong>No results</strong>
                            </div>
                        : <div className="d-flex justify-content-center flex-column">
                            <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        </div>
                    }
                </div>

                <Modal show={show} onHide={() => setShow(false)} >
                    <Modal.Header>
                        <Modal.Title className="text-center col-12">
                            <button onClick={() => setShow(false)} type='button' className="close float-right px-0" data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                            {modalRecipe.name}

                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="mt-2">
                        <div className="row" style={{ display: "block" }}>
                            <div className=" col-sm-12 d-flex justify-content-center">
                                {modalRecipe.image &&
                                    <picture >
                                    <source srcset={modalRecipe.webpUrl} type="image/webp" />
                                    <img src={modalRecipe.image} alt="Recipe example" style={{ maxWidth: "300px" }} className={classes.ModalImg} loading="lazy" />
                                </picture>}
                            </div>
                            <div className=" col-sm-12">
                                {modalRecipe.description && <p className="text-center mx-4">
                                    {modalRecipe.description}
                                </p>}
                                <span className="justify-content-center d-flex" style={{ flexWrap: "wrap" }}>
                                    {modalRecipe.macros?.length > 0 && modalRecipe.macros.map(
                                        ({ macro, qty }) =>
                                            <span className={classes.ModalMacros}>
                                                <span>{macro}:</span>
                                                <span> {qty}</span>
                                            </span>
                                    )}
                                </span>
                                <div className="d-flex justify-content-around w-100 mb-2 mt-1">
                                    {modalRecipe?.serving_size?.length > 0 && <div>
                                        <span><strong> Serving Size: </strong></span> {modalRecipe.serving_size}
                                    </div>}
                                    {modalRecipe?.num_servings?.length > 0 && <div>
                                        <span> <strong> Number of Servings:</strong></span> {modalRecipe.num_servings}
                                    </div>
                                    }
                                </div>
                                <hr />
                                <p style={{ whiteSpace: "pre-line" }}><span className={classes.BoldText} >Ingredients</span> {modalRecipe.ingredients}</p>
                                <p style={{ whiteSpace: "pre-line" }}><span className={classes.BoldText}>Toppings or Add Ins (optional)</span> {modalRecipe.add_ins || "None"}</p>
                                <p style={{ whiteSpace: "pre-line" }}><span className={classes.BoldText}>Directions</span> {modalRecipe.directions}</p>
                                {modalRecipe.link && <p><span className={classes.BoldText} style={{ display: "inline" }}>Link:</span> {modalRecipe.link}</p>}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShow(false)} variant="outline-danger"> Close </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default RecipesPublic